import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { serviceSagaActions } from "../../Information/Service";
import { catalogueSagaActions } from "..";

import { Button, Card, Carousel, Row  } from "react-bootstrap";

import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";

import catalogStyles from "../css/Catalogue.module.css";
import carouselStyles from "../css/Carousel.module.css";
import "../css/Generic.css";

export const DepartmentsCatalogueCarousel = ({ depts, deptsTotalCount, selectedProvince }) => {

  const history = useHistory();


  const dispatch = useDispatch();

  let columnCardsCount = 10; //set this to the number cards to be displayed in earch carousel item

  let dummyArray = Array(Math.ceil(deptsTotalCount / columnCardsCount)).fill(0);

  const handleDeptSelection = (dept) => {

    let deptId = dept.id;
    let provId = selectedProvince.id;

    dispatch(serviceSagaActions.fetchAllServsForDept(deptId, provId));
    dispatch(catalogueSagaActions.setDept(dept));

    history.push({pathname:"/catalogue-management/services", state: { deptId, provId }});

  };

  

  return (
    <Carousel
        prevIcon={<ArrowLeftCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} /> }
        nextIcon={<ArrowRightCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} /> }
        controls={deptsTotalCount > columnCardsCount ? true : false}
        indicators={true}
        interval={null} /* set to null to stop carousel from cycling */
      >
        
        { dummyArray.map((val, y) =>  
          <Carousel.Item key={"yyy_" + y}> 
            <Row>
              {depts.slice(((y)*columnCardsCount),((y+1)*columnCardsCount)).map((dept, z) =>  
                <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex" key={"zzz_" + z}>
                <Card  className={`${carouselStyles.carouselCard} w-100 mb-10`}>
                    <div className="d-flex justify-content-center" style={{borderRadius: '5px', backgroundImage: 'url(../media/bg/bg-1.jpg)', backgroundSize: '100% 100%'}}>
                      <Card.Img
                        variant="top"
                        src={dept.logo_image}
                        style={{ width: '214px', height: '141px', marginTop: '15px', marginBottom: '15px'}}
                      />
                    </div>
                    <Card.Body  className={`${carouselStyles.cardBody}`}>
                      <Card.Title><span style={{fontSize:"1.2rem"}}>{dept.name}</span></Card.Title>
                      <Card.Text>
                        <span style={{fontSize:"1rem", display:"block"}}>{dept.prov_name}</span>
                      </Card.Text>
                      <Button className={`${carouselStyles.cardBodyButton}`} variant="primary" onClick={() => handleDeptSelection(dept)}>View Services</Button>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </Row>
          </Carousel.Item>        
        )} 
    </Carousel>
  );
};
